import PropTypes from 'prop-types';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { useRef, useState } from 'react';
import Dialog from '../../Figure/Dialog/Dialog';

gsap.registerPlugin(ScrollTrigger, useGSAP);

function AnimationColere({ id, imgs, className, containerClassName, credits }) {
    const containerRef = useRef(null);
    const figcaptionRef = useRef(null);

    useGSAP(() => {
        // on sécurise l'appel à gsap
        const container = containerRef.current;
        const figcaption = figcaptionRef.current;
        if(!container || !figcaption) return;

        // on initialise le positionnement de la légende
        gsap.set(figcaption, {
            y: -1 * figcaption.offsetHeight
        });

        // Mise en place de l'animation
        gsap.to(figcaption, {
            y: container.offsetHeight,
            ease: 'none',
            scrollTrigger: {
                trigger: container,
                start: 'top center',
                end: (window.innerWidth > 600) ? 'bottom-=500 center' : 'bottom-=200 center',
                scrub: true
            }
        });

    }, { scope: containerRef});

    // On définit les classes des différents containers
    let figureContainerClassName = `${containerClassName} container-image--absolute-caption-huge-typo quiz-figure`;
    let mediaContainerClasses = "quiz-figure__media-container";

    // On créé l'états autour de la popin
    const [ isPopinOpen, setIsPopinOpen ] = useState(false);

    return (
        <div id={id} className={className} ref={containerRef}>
            <figure className={figureContainerClassName}>
                <div className={mediaContainerClasses}>
                    <picture className="quiz-figure__media-picture">
                        <source srcSet={imgs.desktop} media="(min-width: 600px)" />
                        <img src={imgs.mobile} alt='' />
                    </picture>
                    <button className="button button--legend" aria-label="afficher la légende de l'image" onClick={() => setIsPopinOpen(true)}>
                        <svg role="img" xmlns="http://www.w3.org/2000/svg" width="32" height="32" version="1.1" viewBox="0 0 32 32">
                            <title>afficher la légende de l&apos;image</title>
                            <circle cx="16" cy="16" r="15.12" />
                            <path d="M17.26,10.37c0,.7-.53,1.22-1.27,1.22s-1.25-.51-1.25-1.22.55-1.18,1.25-1.18,1.27.49,1.27,1.18ZM15.03,13.39h1.93v9.42h-1.93s0-9.42,0-9.42Z"/>
                        </svg>
                    </button>
                    <Dialog
                        mediaType='image'
                        medias={imgs}
                        isPopinOpen={isPopinOpen}
                        onClose={() => setIsPopinOpen(false)}>
                        {credits}
                    </Dialog>
                </div>
                <figcaption ref={figcaptionRef} className="quiz-figure__caption">
                    <div>
                        <span>la colère</span>
                    </div>
                </figcaption>
            </figure>
        </div>
    )
}

AnimationColere.propTypes = {
    id: PropTypes.string.isRequired,
    imgs: PropTypes.object.isRequired,
    className: PropTypes.string.isRequired,
    containerClassName: PropTypes.string.isRequired,
    credits: PropTypes.element.isRequired
}

export default AnimationColere;
